import { Box, Link } from '@mui/material';
import { gridStyles, linkStyles } from 'customer-management/styles';
import { useHistory } from 'react-router-dom';
import { UseTableCellProps } from 'react-table';
import { CustomerManagementGridItem } from 'shared/types/customerManagement';

export function LinkColumn(props: UseTableCellProps<CustomerManagementGridItem>) {
  const history = useHistory();
  const {
    value,
    row: {
      original: { masterCustomer, abgBrand },
    },
  } = props;

  return (
    <Box sx={gridStyles}>
      <Link
        sx={linkStyles}
        onClick={() => {
          history.push(`/customer-management/customer-details/${masterCustomer}/${abgBrand}/contractSummary`);
        }}
      >
        {value}
      </Link>
    </Box>
  );
}
